<template>
  <SectionPrice class="mb-5" :data="internetPhoneDataPrice">
    <template #title>
      <div v-if="title" class="font-bold text-center text-xl laptop:text-2xl">
        {{ title }}
      </div>
    </template>
    <div class="flex flex-col justify-between flex-grow">
      <div class="text-center text-xs">
        {{ internetPhoneDataPrice.slot.sal }}
      </div>
      <span class="flex items-center justify-center">
        <!-- <span>از</span> -->
        <span class="mx-1 text-xl font-bold">{{
          internetPhoneDataPrice.slot.price
        }}</span>
        <span>تومان</span>
      </span>
      <div class="text-center">+</div>
      <span class="flex flex-col items-center text-xs mb-2">
        <span> 400/000 تومان</span>
        <span> هزینه راه‌اندازی</span>
      </span>
    </div>
    <div
      class="flex items-center [&>*]:w-[45%]"
      :class="hideOrder ? 'justify-center' : 'justify-between'"
    >
      <BaseButton
        v-if="!hideOrder"
        isLean
        width="full"
        text="ثبت سفارش"
        @click="showMainModal"
      />
      <BaseButtonLink
        isLean
        size="full"
        text="خرید آنلاین"
        styleType="secondary"
        to="/online-shopping/internet-phone/"
      />
    </div>
  </SectionPrice>
</template>

<script setup>
defineProps({
  title: String,
  hideOrder: Boolean,
});

const internetPhoneDataPrice = {
  id: 3,
  title: "",
  label: "مناسب استفاده شخصی و اینماد",
  subTitle: "قیمت گذاری سرویس تلفن اینترنتی نواتل",
  desc: "هزینه تلفن ثابت اینترنتی نواتل شامل هزینه خط، کانال، راه‌اندازی(یکبار پرداخت) و اشتراک سالیانه است.",
  featuers: [
    {
      id: "1",
      text: `قیمت شماره‌های نواتلی از 200 هزار تومان شروع شده و براساس نوع شماره (برنزی، نقره‌ای، طلایی و اپال) متغیر است.`,
    },
    { id: "2", text: "هزینه هر کانال 100 هزارتومان است." },
  ],
  slot: {
    sal: "سالیانه ",
    price: "970/000",
    btnOrder: "ثبت سفارش",
    btnBuy: " خرید آنلاین",
  },
  // offPrice: "۲/۲۴۰/۰۰۰",
};

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};
</script>
